import React, { Fragment, lazy, Suspense } from 'react';
import LazyLoader from '../../components/MasterLayout/LazyLoader';
const BillingAddress = lazy(()=>import('../../components/CheckOut/BillingAddress'))

const BillingPage = () => {
    return (
        <Fragment>
            <Suspense fallback={<LazyLoader/>}>
                <BillingAddress/>
            </Suspense>
        </Fragment>
    );
};

export default BillingPage;